import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MalgaCheckoutFull from "@malga-checkout-full/react";
import { env } from '../config/env';

/**
 * CheckoutPage component that receives a slug from the URL
 * URL format: /:slug
 * 
 * Example: http://localhost:5173/abc123
 */
export function CheckoutPage() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className="checkout-container">
      <MalgaCheckoutFull
        clientId={env.malga.clientId}
        merchantId={env.malga.merchantId}
        publicKey={env.malga.publicKey}
        sessionId={slug}
        pageConfig={{
          brandUrl: "https://plug-settings-prod.s3.amazonaws.com/14ad300c-2c56-4eca-b1ef-e3db4d45df6b/colored_logo.png",
          footerDescription: "",
          backRoute: "https://dio.me",
          delivery: 0
        }}
        dialogConfig={{
          show: true,
          actionButtonLabel: "Continuar",
          errorActionButtonLabel: "Tentar novamente",
          successActionButtonLabel: "Continuar",
          successRedirectUrl: "https://web.dio.me/",
        }}
        onTransactionSuccess={(data) => {
          console.log('Transaction success:', data);
          window.location.href = "https://web.dio.me/";
          // Your specifications here
        }}
        onTransactionFailed={(error) => {}}
      />
    </div>
  );
}
